import {createAction} from "redux-act";
import {SportType} from "modules/utils";

export const setSportName = createAction<SportType>();
